/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import Loading from 'src/Components/Loading';
import { useDeleteTransaction } from 'src/hooks/queries/transactions';
import { toPersianNumbers } from 'src/utils/numbers';
import toPrice from 'src/utils/toPrice';
import DeleteIcon from './assets/Delete.svg';
import TransactionItemWrapper from './styles';

interface Props {
	transaction: any;
}

const TransactionItem: React.FC<Props> = ({ transaction }) => {
	const [deleteButton, setDeleteButton] = useState(false);

	const { mutate: deleteTransaction, isLoading: transactionIsLoading } =
		useDeleteTransaction();

	const handleTransactionClick = () => {
		if (!transactionIsLoading) {
			setDeleteButton(!deleteButton);
		}
	};

	const handleDeleteTransaction = () => {
		deleteTransaction(transaction._id);
	};

	return (
		<TransactionItemWrapper>
			<div className='info' onClick={handleTransactionClick}>
				<span className='title'>{transaction.title}</span>
				{transaction.tags.length > 0 && (
					<span className='tags'>{transaction.tags.join(', ')}</span>
				)}
			</div>
			<div className='details'>
				<span className='price'>
					{toPersianNumbers(toPrice(transaction.price))}{' '}
					<span className='currency'>تومان</span>
				</span>
			</div>
			{deleteButton && (
				<button
					type='button'
					className='delete-button'
					onClick={handleDeleteTransaction}
					disabled={transactionIsLoading}
				>
					{transactionIsLoading ? (
						<Loading size={19} />
					) : (
						<img src={DeleteIcon} alt='' />
					)}
				</button>
			)}
		</TransactionItemWrapper>
	);
};

export default TransactionItem;
